<div class="email-tags-input" [class.focused]="isInputFocused" [class.disabled]="disabled">
  <div class="tags-container">
    <!-- Display existing tags -->
    <div class="tag" *ngFor="let tag of tags; let i = index">
      <span class="tag-text">{{ tag }}</span>
      <button
        type="button"
        class="tag-remove"
        (click)="removeTag(i)"
        [disabled]="disabled"
        [attr.aria-label]="'Remove ' + tag">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Input field -->
    <input
      type="text"
      id="email-tag-input"
      class="tag-input"
      [(ngModel)]="inputValue"
      [placeholder]="placeholder"
      [disabled]="disabled"
      (keydown)="onInputKeydown($event)"
      (blur)="onInputBlur()"
      (focus)="onInputFocus()"
      autocomplete="off"
      [attr.aria-label]="placeholder || 'Add email tag'"
    />
  </div>
</div>

